import dateField from "../../common/date-field";
import rangeSlider from "../../common/range-slider";
import decimalField from "../../common/decimal-field.vue";
import { hasValue } from "../../../utils/functions.js";

export default {
  name: "partnerMerchantsPreview",
  components: {
    dateField,
    rangeSlider,
    decimalField
  },
  data() {
    return {
      PartnerTypeCode: 0,
      anticipationTaxList: [],

      isSearchZipCode: false,
      approve: false,
      isView: false,
      countFilter: 0,
      mCurrentStep: 0,
      mCurrentStepConfirm: 0,
      selectMerchantPreview: null,
      
      mSteps: ["compate", "owner", "contact", "information", "security","confirmation"],
      listBackgroundCheckStatus: [
        { Id: 0, Name: "Aguardando Onboard" },
        { Id: 1, Name: "Aprovado" },
        { Id: 2, Name: "Rejeitado" }
      ],
      filter: this.DefaultFilter(),
      infoMerchantPreview: this.DefaultInfoMerchantPreview(),

      merchantsPreview: [],
      cities: [],
      countries: [],
      states: [],
      listStatus: [],
      backgroundCheckList: [],

      validatedCompanyStep: false,
      validatedResponsibleStep: false,
      validatedTaxStep: false,
      validatedTechStep: false,
      validatedChangeEmail: false,
      validatedMerchant: false,
      validatedUpdatePartner: false,
      validatedMerchantContract: false,
      validatedReasonStep: false,

      loading: false,
      loadingInfo: null,
      loadingStatus: null,
      loadingValidateMerchant: false,

      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0
      },

      routeProspect: false,
      infoProspect: null,
    };
  },
  computed: {
    BankSlipTax: {
      get() { return this.$store.getters.BankSlipTax },
      set(value) { this.$store.commit("SET_MERCHANTPREVIEW_BANKSLIP_TAX", value) }
    },
    CreditCardTax: {
      get() { return this.$store.getters.CreditCardTax },
      set(value) { this.$store.commit("SET_MERCHANTPREVIEW_CREDITCARD_TAX", value) }
    },
    PixTax: {
      get() { return this.$store.getters.PixTax },
      set(value) { this.$store.commit("SET_MERCHANTPREVIEW_PIX_TAX", value) }
    },
    AnticipationTax: {
      get() { return this.$store.getters.AnticipationTax },
      set(value) { this.$store.commit("SET_MERCHANTPREVIEW_ANTICIPATION_TAX", value) }
    },
    BankSlipCommission: {
      get() { return this.$store.getters.BankSlipCommission },
      set(value) { this.$store.commit("SET_MERCHANTPREVIEW_BANKSLIP_COMMISSION", value) }
    },
    CreditCardCommission: {
      get() { return this.$store.getters.CreditCardCommission },
      set(value) { this.$store.commit("SET_MERCHANTPREVIEW_CREDITCARD_COMMISSION", value) }
    },
    PixCommission: {
      get() { return this.$store.getters.PixCommission },
      set(value) { this.$store.commit("SET_MERCHANTPREVIEW_PIX_COMMISSION", value) }
    },
    AnticipationCommission: {
      get() { return this.$store.getters.AnticipationCommission },
      set(value) { this.$store.commit("SET_MERCHANTPREVIEW_ANTICIPATION_COMMISSION", value) }
    },
    PlataformUseText(){
      if(this.plataformUse == "IsInterface")
       return "Manual"
      if(this.plataformUse == "IsApi")
       return "API" 
      if(this.plataformUse == "IsOtherSoftware")
       return "Software de terceiro" 
    },
    Country() {
      return this.infoMerchantPreview.Address.Country.Id;
    },
    State() {
      return this.infoMerchantPreview.Address.State.Initials;
    },
    CommissionCompetences() {
      return this.$store.getters.CommissionCompetence;
    },
    FormattedAddress() {
      //Av. Praia de belas, 91520-100 - Praia de belas Shopping, RS - Porto Alegre - Brasil
      this.infoMerchantPreview.Address.Country.Name = this.countries.find(
        country => {
          return country.Id === this.infoMerchantPreview.Address.Country.Id}
      ).Name;
      this.infoMerchantPreview.Address.City.Name = this.cities.find(
        city => city.CodeIBGE === this.infoMerchantPreview.Address.City.CodeIBGE
      ).Name;

      //Av. Praia de belas, 91520-100 - Praia de belas Shopping, RS - Porto Alegre - Brasil
      this.infoMerchantPreview.Address.City.Id = this.cities.find(
        city => city.CodeIBGE === this.infoMerchantPreview.Address.City.CodeIBGE
      ).Id;
      this.infoMerchantPreview.Address.State.Id = this.states.find(
        state => state.Initials === this.infoMerchantPreview.Address.State.Initials
      ).Id;

      let formatted = `${this.infoMerchantPreview.Address.Street}, ${this.infoMerchantPreview.Address.Number} - ${this.infoMerchantPreview.Address.District}, ${this.infoMerchantPreview.Address.City.Name} - ${this.infoMerchantPreview.Address.State.Initials} - ${this.infoMerchantPreview.Address.Country.Name}`;
      return formatted;
    },
    MaxSteps() {
      return this.isView ? 4 : 5;
    }
  },
  watch: {
    "pagination.PageNumber": function() {
      this.ListMerchantPreview();
    },
    "pagination.RowsPerPage": function() {
      this.ListMerchantPreview();
    },
    State(selected, old) {
      // Update City list when the State (of Country) is changed.
      if (selected != null) {
        this.ListCity();
        if (selected != old && old != undefined && !this.isSearchZipCode) {
          this.infoMerchantPreview.Address.City.CodeIBGE = null;
        }
      } else {
        this.cities = [];
        this.infoMerchantPreview.Address.City.CodeIBGE = null;
      }
      if (this.isSearchZipCode) this.isSearchZipCode = false;
    },
    Country(selected, old) {
      // Update State list when the Country is changed.
      if (selected != null) {
        this.ListState(selected);
        if (selected != old && old != undefined && !this.isSearchZipCode) {
          this.infoMerchantPreview.Address.State.Initials = null;
        }
      } else {
        this.states = [];
        this.infoMerchantPreview.Address.State.Initials = null;
      }
      if (this.isSearchZipCode) this.isSearchZipCode = false;
    }
  },
  beforeMount() {
    this.PartnerTypeCode = this.$partnerTypeCode();
    this.GetAnticipationConfigurationTaxes();
  },
  mounted() {
    this.$requestGetCommissionCompetence();
    this.ListStatus();
    this.ListCountry();
    this.ListMerchantPreview();

    if (this.$route.params.prospect != null && this.$route.params.prospect != undefined) {
      this.OpenValidateMerchant();
      this.infoProspect = this.$route.params.prospect;
      this.routeProspect = true;
      this.infoValidateMerchant = {
        Email: null,
        ResponsibleIdentity: null,
        Identity: this.infoProspect.Identity
      };
    }
  },
  methods: {
    GetAnticipationConfigurationTaxes() {
      this.$store.dispatch("ListConfigurationTax", {})
      .then(response => {
        const anticipationTaxList = [];

        const configurationTaxesList = response.Objects;
        configurationTaxesList.map(configurationTax => {
          if (configurationTax.PaymentMethod.Code == 15) {
            anticipationTaxList.push(configurationTax);
          }
        })

        this.anticipationTaxList = anticipationTaxList;
      })
    },
    floatToReal(v, t) {
      if (t === 2) {
        return "R$ " + v.toFixed(2).replace(".", ",");
      } else {
        return v.toFixed(2) + "%";
      }
    },
    OpenValidateMerchant() {
      this.routeProspect = false;
      this.loadingValidateMerchant = false;
      this.validatedCompanyStep = false;
      this.validatedMerchant = false;
      this.infoValidateMerchant = {
        Email: null,
        ResponsibleIdentity: null,
        Identity: null
      };
      this.$bvModal.show("mValidateMerchant");
    },
    OpenModalFilter() {
      this.$bvModal.show("mFilter");
    },
    Filter: function() {
      this.$bvModal.hide("mFilter");
      this.ListMerchantPreview();
    },
    ListMerchantPreview() {
      this.loading = true;

      this.countFilter = 0;
      if (hasValue(this.filter.Id)) this.countFilter++;
      if (hasValue(this.filter.Name)) this.countFilter++;
      if (hasValue(this.filter.Identity)) this.countFilter++;
      if (hasValue(this.filter.CodeMerchantPreviewStatus)) this.countFilter++;
      if (hasValue(this.filter.IdBackgroundCheckStatus)) this.countFilter++;
      if (hasValue(this.filter.InitialDate)) this.countFilter++;
      if (hasValue(this.filter.FinalDate)) this.countFilter++;
      if (hasValue(this.filter.ExcludeBackgroundCheck)) this.ExcludeBackgroundCheck++;

      let data = {
        ...this.pagination,
        "Object.Id": this.filter.Id,
        "Object.Identity": this.filter.Identity,
        "Object.Name": this.filter.Name,
        "Object.MerchantPreviewStatus.Code": this.filter.CodeMerchantPreviewStatus,
        "Object.BackgroundCheck.Status": this.filter.IdBackgroundCheckStatus,
        InitialDate: this.filter.InitialDate,
        EndDate: this.filter.FinalDate,
        ExcludeBackgroundCheck: this.filter.ExcludeBackgroundCheck,
        "Object.Source": "PARTNER"
      };

      this.$store
        .dispatch("ListMerchantPreview", { params: data })
        .then(response => {
          this.merchantsPreview = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro carregar os clientes pré-cadastrados.", error);
        })
        .finally(() => (this.loading = false));
    },
    ResetFilter() {
      this.filter = this.DefaultFilter();
      this.ListMerchantPreview();
    },
    ListStatus() {
      this.$store
        .dispatch("ListMerchantPreviewStatus")
        .then(response => {
          this.listStatus = response;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro carregar a lista de situações", error);
        });
    },
    SetDefaultTaxesAndCommissions() {
      const avaiablePaymentMethods = ["BankSlip", "CreditCard", "Pix", "Anticipation"];

      for (const method of avaiablePaymentMethods) {
        const numberOfTaxes = this.CommissionCompetences[method].Taxes.length;
        const highestTax = this.CommissionCompetences[method].Taxes[numberOfTaxes - 1].Tax;
        const PAYMENT_METHOD = method.toUpperCase();
        if (method === "Anticipation") {
          this.$store.commit("SET_MERCHANTPREVIEW_" + PAYMENT_METHOD + "_TAX", this.anticipationTaxList[0].Amount);
        } else {
          this.$store.commit("SET_MERCHANTPREVIEW_" + PAYMENT_METHOD + "_TAX", highestTax);
        }

        const commission = this.CommissionCompetences[method].Taxes[numberOfTaxes - 1].Commission;
        this.$store.commit("SET_MERCHANTPREVIEW_" + PAYMENT_METHOD + "_COMMISSION", commission);
      }
      this.$store.commit("SET_TAX_INFO", null);
    },
    OpenMerchantPreview(id, view) {
      this.mCurrentStep = 0;
      this.isView = view;

      if (view) {
        this.infoMerchantPreview = this.DefaultInfoMerchantPreview();
        this.modalTitle = "Detalhes do cadastro";
        this.GetMerchantPreview(id);
      } else {
        this.modalTitle = "Realizar cadastro";
        this.SetDefaultTaxesAndCommissions();
      }

      this.$bvModal.show("mFormMerchantPreview");
    },
    GetMerchantPreview(id) {
      this.loadingInfo = true;
      this.$store
        .dispatch("GetMerchantPreview", { id: id })
        .then(response => {
          this.infoMerchantPreview = response;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao obter as informações do cadastro", error);
        })
        .finally(() => {
          this.loadingInfo = false;
        });
    },
    GetCommissionCompetences(){
      let CommissionCompetences = [];

      if (hasValue(this.CommissionCompetences.BankSlip) && hasValue(this.CommissionCompetences.BankSlip.Taxes)){
        this.CommissionCompetences.BankSlip.Taxes[0].Tax = this.BankSlipTax;
        CommissionCompetences.push(this.CommissionCompetences.BankSlip.Taxes[0]);
      }

      if (hasValue(this.CommissionCompetences.CreditCard) && hasValue(this.CommissionCompetences.CreditCard.Taxes)){
        this.CommissionCompetences.CreditCard.Taxes[0].Tax = this.CreditCardTax;
        CommissionCompetences.push(this.CommissionCompetences.CreditCard.Taxes[0]);
      }

      if (hasValue(this.CommissionCompetences.Pix) && hasValue(this.CommissionCompetences.Pix.Taxes)){
        this.CommissionCompetences.Pix.Taxes[0].Tax = this.PixTax;
        CommissionCompetences.push(this.CommissionCompetences.Pix.Taxes[0]);
      }

      if (this.PartnerTypeCode == 1) {
        if (hasValue(this.CommissionCompetences.Anticipation) && hasValue(this.CommissionCompetences.Anticipation.Taxes)){
          this.CommissionCompetences.Anticipation.Taxes[0].Tax = this.AnticipationTax;
          CommissionCompetences.push(this.CommissionCompetences.Anticipation.Taxes[0]);
        }
      } else {
        if (hasValue(this.CommissionCompetences.Anticipation) && hasValue(this.CommissionCompetences.Anticipation.Taxes)){
          this.CommissionCompetences.Anticipation.Taxes[0].Tax = this.AnticipationTax;
          this.CommissionCompetences.Anticipation.Taxes[0].Commission = 0;
          CommissionCompetences.push(this.CommissionCompetences.Anticipation.Taxes[0]);
        }
      }
      return CommissionCompetences;
    },
    AddMerchantPreview() {
      this.loadingInfo = true;
      this.infoMerchantPreview.CommissionCompetences = this.GetCommissionCompetences();
      if (this.routeProspect) {
        this.infoMerchantPreview.Prospect = this.infoProspect;
        this.$store
          .dispatch("AddPropectMerchantPreview", this.infoMerchantPreview)
          .then(
            () => {
              this.$bvModal.hide("mFormMerchantPreview");
              this.ListMerchantPreview();
              this.routeProspect = false;
              this.$makeToast("Foi inicializado o onboarding do cliente!", "success", "Onboarding de Clientes");
            },
            error => {
              this.$makeToast("Não foi possível iniciar o onboarding do Cliente.", "danger", "Onboarding de Clientes", error);
            }
          )
          .finally(() => {
            this.loadingInfo = false;
          });
      } else {
        this.$store
          .dispatch("AddPartnerMerchantPreview", this.infoMerchantPreview)
          .then(() => {
            this.$bvModal.hide("mFormMerchantPreview");
            this.ListMerchantPreview();
            this.$makeToast("Foi inicializado o onboarding do cliente!", "success", "Onboarding de Clientes");
          })
          .catch(error => {
            this.$makeToast("Não foi possível iniciar o onboarding do Cliente.", "danger", "Onboarding de Clientes", error);
          })
          .finally(() => {
            this.loadingInfo = false;
          });
      }
    },
    HideModal: function() {
      this.$bvModal.hide("mFormMerchantPreview");
    },
    ListState(countryId) {
      this.$store
        .dispatch("GetStates", { idCountry: countryId })
        .then(response => {
          this.states = response;
        })
        .catch(error => this.$makeToast(undefined, "danger", "Erro ao obter lista de estados", error));
    },
    ListCountry() {
      this.$store
        .dispatch("GetCountries")
        .then(response => {
          this.countries = response;
        })
        .catch(error => this.$makeToast(undefined, "danger", "Erro carregar a lista de países", error));
    },
    ListCity() {
      this.$store
        .dispatch("GetCities", {
          stateInitials: this.infoMerchantPreview.Address.State.Initials
        })
        .then(response => {
          this.cities = response;
        })
        .catch(error => {
          this.$makeToast("Não foi possível buscar as cidades.", "danger", "Listagem de cidades", error);
        });
    },
    GoToStep(stepToGo) {
      if(!this.isView){
        switch (this.mCurrentStep) {
          case 0: // Empresa
            this.validatedCompanyStep = true;
            this.CheckValidityStepCompany(stepToGo);
            break;
          case 1: // Responsavel
            this.validatedResponsibleStep = true;
            this.CheckValidityStepResponsible(stepToGo);
            break;
          case 2: // Contato tecnico
            this.validatedContactTechStep = true;
            this.CheckValidityStepContactTechStep(stepToGo);
            break;
          case 3: // Taxas
            this.validatedTaxStep = true;
            this.CheckValidityStepTax(stepToGo);
            break;
          default:
            if (stepToGo < this.mSteps.length && stepToGo >= 0) {
              if (stepToGo < this.mCurrentStep) {
                this.mCurrentStep = stepToGo;
              } else {
                this.ProcessNextStep(stepToGo);
              }
            }
        }
      }else{
        if (stepToGo < this.mSteps.length && stepToGo >= 0) {
          if (stepToGo < this.mCurrentStep) {
            this.mCurrentStep = stepToGo;
          } else {
            this.ProcessNextStep(stepToGo);
          }
        }
      }
    },
    ProcessNextStep(nextStep = null) {
      if (nextStep != null) this.mCurrentStep = nextStep;
      else this.NextStep();
    },
    NextStep() {
      if(!this.isView){
        const nextStep = this.mCurrentStep + 1;
        switch (this.mCurrentStep) {
          case 0: // Empresa
            this.validatedCompanyStep = true;
            this.CheckValidityStepCompany(nextStep);
            break;
          case 1: // Responsavel
            this.validatedResponsibleStep = true;
            this.CheckValidityStepResponsible(nextStep);
            break;
          case 2: // Contato tecnico
            this.validatedContactTechStep = true;
            this.CheckValidityStepContactTechStep(nextStep);
            break;
          case 3: // Taxas
            this.validatedTaxStep = true;
            this.CheckValidityStepTax(nextStep);
            break;
          default:
            if (this.mCurrentStep < 5) {
              this.mCurrentStep += 1;
            }
            break;
        }
      }else{
        if (this.mCurrentStep < 5) {
          this.mCurrentStep += 1;
        }
        if(this.mCurrentStep == 3 && this.isView){
          this.mCurrentStep += 1;
        }
      }
    },
    BackStep: function() {
      if (this.mCurrentStep >= 1) {
        this.mCurrentStep -= 1;
      }
      if(this.mCurrentStep == 3 && this.isView){
        this.mCurrentStep -= 1;
      }
    },
    GetClass: function(id) {
      return id == 0 ? "fas fa-minus" : "";
    },
    BackgroundCheckStatusSum: function(StatusIdentities) {
      if (!hasValue(StatusIdentities) || StatusIdentities.length < 2) {
        return "QSA não identificado";
      }
      if (StatusIdentities.some(elem => elem.Status == 2)) {
        return "Reprovado";
      }
      if (StatusIdentities.every(elem => elem.Status == 1)) {
        return "Aprovado";
      }
      return "Aguardando Onboard";
    },
    ValidateMerchant() {
      this.validatedMerchant = true;
      this.$refs.ValidateMerchantForm.validate().then(isValid => {
        if (isValid) {
          this.validatedMerchant = false;
          this.loadingValidateMerchant = true;
          this.$store
            .dispatch("ValidateMerchant", this.infoValidateMerchant)
            .then(response => {
              if (response.HasErrorValidate) {
                this.ConfirmHasErrorValidate(response);
              } else {
                this.PreSetMerchantPreview(response);
              }
            })
            .catch(error => {
              this.$makeToast(undefined, "danger", "Erro ao validar o cliente", error);
            })
            .finally(() => {
              this.loadingValidateMerchant = false;
            });
        }
      });
    },
    PreSetMerchantPreview(response) {
      this.infoMerchantPreview = this.DefaultInfoMerchantPreview();

      this.infoMerchantPreview.Name = response.Name;
      this.infoMerchantPreview.IsMEI = response.IsMEI;
      this.infoMerchantPreview.Identity = response.Identity;
      this.infoMerchantPreview.ResponsibleName = response.ResponsibleName;
      this.infoMerchantPreview.ResponsibleIdentity = response.ResponsibleIdentity;
      this.infoMerchantPreview.Email = response.Email;
      this.isValidated = true;

      this.$bvModal.hide("mValidateMerchant");
      this.OpenMerchantPreview();
    },
    GetAddressByCep() {
      let zipCodeNumber = this.infoMerchantPreview.Address.ZipCode.replace(/\D+/gm, "");

      if (zipCodeNumber.length != 8) {
        this.$makeToast("O CEP digitado não é válido. " + zipCodeNumber, "danger", "CEP inválido");
        return;
      }

      this.$store
        .dispatch("GetAddressByCep", {
          zipCode: zipCodeNumber
        })
        .then(response => {
          if (response.erro) {
            this.$makeToast("Verifique o número digitado e tente novamente.", "warning", "CEP não encontrado");
            return;
          }
          this.isSearchZipCode = true;

          this.infoMerchantPreview.Address.Country.Id = 24;
          this.infoMerchantPreview.Address.State.Initials = response.uf;

          this.infoMerchantPreview.Address.Street = response.logradouro;
          this.infoMerchantPreview.Address.District = response.bairro;

          this.infoMerchantPreview.Address.City.CodeIBGE = response.ibge;
        })
        .catch(error => {
          this.$makeToast("Não foi possível buscar o endereço.", "danger", "Busca de endereço", error);
        });
    },
    CheckValidityStepCompany(nextStep) {
      this.$refs.CompanyStep.validate().then(valid => {
        if (valid) {
          if (nextStep == null) {
            this.GoNextStep();
          } else {
            this.mCurrentStep = nextStep;
          }
        }
      });
    },
    CheckValidityStepResponsible(nextStep) {
      var name = true;
      var cpf = true;
      this.$refs.ResponsibleNameStep.validate().then(field => {
        name = field.valid;
      });
      this.$refs.ResponsibleCpfStep.validate().then(field => {
        cpf = field.valid;
      });
      this.$refs.ResponsibleStep.validate().then(valid => {
        if (valid && name && cpf) {
          if (nextStep == null) {
            this.GoNextStep();
          } else {
            this.mCurrentStep = nextStep;
          }
        }
      });
    },
    CheckValidityStepContactTechStep(nextStep) {
      this.$refs.TechStep.validate().then(valid => {
        const isPristine = this.$refs.TechStep.ctx.pristine;

        if (!valid && !isPristine) {
          this.validatedContactTechStep = true;
        } else {
          if (nextStep == null) {
            this.GoNextStep();
          } else {
            this.mCurrentStep = nextStep;
          }
          this.validatedContactTechStep = false;
        }
      });
    },
    CheckValidityStepTax(nextStep) {
      this.$refs.TaxStep.validate().then(valid => {
        if (valid) {
          if (nextStep == null) {
            this.GoNextStep();
          } else {
            this.mCurrentStep = nextStep;
          }
        }
      });
    },
    DefaultFilter() {
      return {
        Name: null,
        Identity: null,
        CodeMerchantPreviewStatus: null,
        IdBackgroundCheckStatus: 3,
        InitialDate: null,
        FinalDate: null,
        ExcludeBackgroundCheck: false
      };
    },
    DefaultInfoMerchantPreview() {
      return {
        Name: null,
        FantasyName: null,
        Identity: null,
        ResponsibleName: null,
        ResponsibleIdentity: null,
        Email: null,
        ResponsiblePhone: null,
        TechName: null,
        TechIdentity: null,
        TechEmail: null,
        IsMEI: false,
        Address: {
          Street: "",
          District: null,
          Number: "",
          ZipCode: "",
          Complement: "",
          City: {
            Name: null,
            Id: null,
            CodeIBGE: null
          },
          State: {
            Name: null,
            Initials: null
          },
          Country: {
            Name: null,
            Id: null
          }
        },
        MerchantPreviewStatus:{
          Id: 0,
          Code: null,
          Name: null
        },
        MerchantPreviewHistory: {
          Id: 0,
          MerchantPreview: null,
          MerchantPreviewStatus: null,
          ReasonInternal:"",
          UserInternal: { 
            UserProfileInternal:null,
            UserInternalRoot:null,
            Occupation:null,
            Id:0,
            Name:"",
            Identity:null,
            Email:null,
            Phone:null,
            Thumbprint:null,
            Token:null,
            Image:null,
            PictureUrl:null,
            SecurePassword:null,
            IsExpiredPassword:false,
            PasswordSalt:null,
            IsExcluded:false,
            IsEnabledChange:false,
            TokenLiveChat:null,
            SessionId:null,
          },
        },
        AdditionalInformation: {
          IsOperation: false,
          GrossBillingAmount: 0,
          IsApi: false,
          IsInterface: false,
          IsOtherSoftware: false,
          IsMarketplace: false
        }
      };
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/partnersMerchantPreview/partnersMerchantPreview.js